import { useEffect } from 'react';
import { Button, Modal } from '@warp-ds/react';
import { useLingui } from '@lingui/react';
import { ConfirmationModalType } from '../../../../types/uiTypes';
import usePulse from '../../../../hooks/usePulse';
import { t } from '../../../../../locales/texts';

type Props = {
    isOpen: boolean;
    close: () => void;
    uiText: ConfirmationModalType;
};

/**
 * This modal will let the user know in case the API-call to suggest shipping (Be om Fiks ferdig) fails.
 */
const ErrorModal = ({ isOpen, close, uiText }: Props) => {
    const { trackViewSuggestShippingFailed } = usePulse();
    const { i18n } = useLingui();

    useEffect(() => {
        trackViewSuggestShippingFailed();
    }, []);

    return (
        <Modal
            open={isOpen}
            title={i18n._(t.makeSuggestion.error.title)}
            footer={
                <div data-testid="error-state" className="flex space-x-12">
                    <Button onClick={close} className="border-0">
                        {uiText.actions.abort.text}
                    </Button>
                    <finn-contact-button></finn-contact-button>
                </div>
            }
        >
            <p>{i18n._(t.suggestShipping.errorState.info)}</p>
        </Modal>
    );
};

export default ErrorModal;
